import { NgFor, NgIf } from '@angular/common';
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { CentsCurrencyPipe } from '@common/centsCurrency.pipe';
import { OrderSummaryRow } from '@common/order-summary-row';

@Component({
  selector: 'app-embedded-order-summary',
  templateUrl: './embedded-order-summary.component.html',
  styleUrls: ['./embedded-order-summary.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [NgFor, NgIf, CentsCurrencyPipe],
})
export class EmbeddedOrderSummaryComponent {
  @Input() public itemRows: OrderSummaryRow[] = [];
  @Input() public totalInCents: number = 0;
}
